exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".property-in-row {  \r\n  margin-top: 15px; \r\n}\r\n\r\n.header-seccion-form {\r\n\tbackground-color: #d2d0d0;\t\r\n}\r\n\r\n.content-help-desktop {\r\n\tbackground-color: #30B0D0;\r\n\tcolor: white;\r\n\tmin-height: 0px;\r\n\tpadding: 10px;\r\n\tborder-radius: 5px;\r\n}\r\n\r\n.content-help-desktop:empty {\r\n\tdisplay: none;\r\n}\r\n/*css boton flotante*/\r\n.fixed-action-btn {\r\n\tbottom: 5%;\r\n\tmargin-right: 85px;\r\n}\r\n\r\np {\r\n\tfont-size: 13px;\r\n}\r\n\r\n.icon-help {\r\n\tcolor: gray;\r\n    font-size: 16px;\r\n    margin-left: 10px;\r\n\tposition: inherit;\r\n\tcursor: pointer;\r\n}\r\n\r\n.frm {\r\n\tbackground-color: white;\r\n}\r\n\r\n.buttons-bottom-bar {\r\n\tmargin-top: 30px;\r\n}\r\n\r\n.content-large {\t\r\n\tmax-height: 250px;\r\n\toverflow: auto;\r\n\ttext-align: justify;\r\n}\r\n\r\n.card-question {\r\n\tmargin-bottom: 20px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-experto/formulario/formulario.component.css
// module id = ../../../../../src/app/components/formulario-experto/formulario/formulario.component.css
// module chunks = main